import { Boxes, Camera, PawPrint, Radar } from "lucide-react";
import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

const icons = [Boxes, Camera, Radar, PawPrint];

export function Solutions({ content, media = [] }) {
  return (
    <section id="solutions" className="section" data-slide="06" data-testid="solutions-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="solutions-overline">{content.overline}</p>
        <h2 data-testid="solutions-title">{content.title}</h2>
      </div>

      <div className="solution-grid" data-testid="solution-cards">
        {content.domains.map((domain, index) => {
          const Icon = icons[index] || Boxes;
          return (
            <article className="solution-card" key={domain.title} data-testid={`solution-card-${index + 1}`}>
              <CardMediaSlot image={media[index]?.image} label={domain.title} testId={`solution-media-${index + 1}`} className="solution-media" />
              <div className="solution-icon" data-testid={`solution-icon-${index + 1}`}>
                <Icon size={24} aria-hidden="true" />
              </div>
              <p className="card-eyebrow" data-testid={`solution-eyebrow-${index + 1}`}>{domain.eyebrow}</p>
              <h3 data-testid={`solution-title-${index + 1}`}>{domain.title}</h3>
              <p className="solution-description" data-testid={`solution-description-${index + 1}`}>{domain.description}</p>

              <ul className="feature-list" data-testid={`solution-feature-list-${index + 1}`}>
                {domain.items.map((item) => (
                  <li key={item} data-testid={`solution-feature-${index + 1}-${item.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>{item}</li>
                ))}
              </ul>

              <div className="product-tags" data-testid={`solution-product-tags-${index + 1}`}>
                {domain.products.map((product) => (
                  <span key={product} data-testid={`solution-product-${product.toLowerCase().replaceAll(" ", "-")}`}>{product}</span>
                ))}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}